import {
  CARD_MACHINE_PAYMENT_REFERENCE_ID,
  CARD_MACHINE_DETAILS_OBJECT
} from '../actions/Index';

const initState = {
  cardMachineReferenceId: '',
  cardMachineDetailsObject: {}
};

export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case CARD_MACHINE_PAYMENT_REFERENCE_ID:
      return {
        ...state,
        cardMachineReferenceId: payload.cardMachineReferenceId
      };
    case CARD_MACHINE_DETAILS_OBJECT:
      return {
        ...state,
        cardMachineDetailsObject: payload.cardMachineDetailsObject
      };
    default:
      return state;
  }
}
